import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { api } from "../lib/api";
import NotFound from "./NotFound";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function NewsDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); setError(false);
    api.get(`/news/${slug}`).then((r) => setPost(r.data)).catch(() => setError(true)).finally(() => setLoading(false));
  }, [slug]);

  if (error) return <NotFound />;
  if (loading || !post) return <div style={{ minHeight: "60vh" }} />;

  const paragraphs = (post.body || "").split(/\n\s*\n/).filter(Boolean);

  return (
    <div data-testid="news-detail-page">
      <Seo title={`${post.title} — Lemur Quality`} description={post.excerpt} />
      <PageHeader eyebrow={post.date || "Insights & News"} title={post.title} lead={post.excerpt} crumb={post.title} />
      <section className="section bg-paper">
        <div className="wrap">
          <Reveal className="d-lead" style={{ maxWidth: 820 }}>
            {post.cover_media_id && (
              <img src={`${BACKEND_URL}/api/media/${post.cover_media_id}`} alt={post.title} loading="lazy"
                style={{ width: "100%", aspectRatio: "16 / 9", objectFit: "cover", borderRadius: 18, marginBottom: 30 }} />
            )}
            {paragraphs.map((p, i) => <p key={i} data-testid="news-paragraph">{p}</p>)}
            <div style={{ marginTop: 30 }}>
              <Link to="/resources/insights-news" className="btn btn-ghost" data-testid="back-to-news">← All insights &amp; news</Link>
            </div>
          </Reveal>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
